export const environment = {
    production: false,
    environmentName: 'staging',
    apiUrl: 'https://cremations-staging.dankospark.co.za/api/'
}
